import { Component, Input, OnDestroy, OnInit, AfterViewInit, ViewChild, Inject, ElementRef, Renderer2 } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppDataService, ConfigService, RiderService, SignalrService, XpressUserService } from 'app/services';
import { OperatorDriversService } from 'app/services/operator/operator-drivers.service';
import { Utils } from 'app/utils';
import * as moment from 'moment';
import {
    BackOfficeEnum,
    LastActiveTypeModel,
    RiderSourceType,
    RiderSourceTypeEnum,
    RiderVehicleTypeEnum,
    ServiceTypeEnum,
    XpressRiderStatus,
    DriverCampaignType,
    Xpress50IncentiveType, FieldTypeEnum, XpressUserRoleEnum, ExportFileTypeEnum,
    DriverTypeEnum,
    MenuPermissionConfig,
    MenuPermissionActionEnum,
} from 'app/models';
import { MenuHomeEnum } from 'app/components/home';
import { Observable, Subscription } from 'rxjs';
import { AppComponent } from 'app/app.component';
import { BusinessDocumentsEnum } from 'app/operator/operator-signup/signup-params';
import { StylesStatus } from 'app/models/users/StylesStatus';
import { XpressCalendarEnum } from 'app/xpress-calendar/xpress-calendar.enum';
import { ColumnSelectorComponent } from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';
import { ProductsAvailed } from './driver-detail/driver-commerce/products-availed';
import { ProvideTestId, TEST_ID_TOKEN } from 'app/providers';

@Component({
    selector: 'drivers',
    templateUrl: './drivers.component.html',
    styleUrls: ['./drivers.component.scss',
        '../../../../styles/paginator.scss'],
    providers: [MessageService, ProvideTestId('drivers')]
})
export class DriversComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input()
    public menuPermissionActive!: string;

	public backOfficeEnum = BackOfficeEnum;
    private firstLoad: boolean = true;
    public backOfficeActive!: BackOfficeEnum;
    public tableName: string = 'Drivers';
    public fieldTypeEnum = FieldTypeEnum;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    @Input()
    set _backOfficeActive(value: BackOfficeEnum) {
        if (this.backOfficeActive) {
			this.backOfficeActive = value;
			this.initializeCols();
            this.callBackOfficeForFilter(this.backOfficeActive);
            this.driverHeaderSearch = [];

            if (this.backOfficeActive && !this.lazyLoadHandled) {
                this.handleLazyLoad({
                    first: 0,
                    rows: this.rowsPerPage
                });
            }
        } else {
			this.backOfficeActive = value;
			this.initializeCols();
            this.callBackOfficeForFilter(this.backOfficeActive);
        }
    }

    private lazyLoadHandled: boolean = true;
    public menuHomeEnumActive!: MenuHomeEnum;
    public invitedDriversOnly = false;
    @Input()
    set _menuHomeEnumActive(value: MenuHomeEnum) {
        this.menuHomeEnumActive = value;
    }

    public static readonly MAX_UPLOAD_FILE_SIZE = 10485760; //10Mb

    @ViewChild('invitesDropdown')
    public invitesDropdown!: any;

    public initialPermission: string = '';
    public showInviteDialog: boolean = false;
    public inviteDialogHeader: string = '';
    public singleInvitedDriver: InvitedDriver = new InvitedDriver();
    public readonly invitePhoneCountryCode = '+63';
    public invitePhoneLocal = '';
    public invitePhoneValidated = false;
    public invitePhoneValidationSuccess = false;
    public invitePhoneValidationSeverity: 'success' | 'error' | 'info' | 'warning' = 'error';
    public invitePhoneValidationMessage = '';
    public invitePhoneValidating = false;
    public inviteDetailsLocked = false;
    public inviteRequiresRegistration = false;
    public inviteEmailError = '';
    public inviteEmailAvailable = false;

    public file: any;
    public invitedInterval: any;
    public invitedDriversProgressBar: number = 0;
    public invitedDriversUploadError: boolean = false;
    public csvFileUploaded: boolean = false;

    public riderStatus = XpressRiderStatus;

    public driverVehicleTypes: any[] = [];
    public driverServiceTypes: any[] = [];
	public riderType: DriverTypeEnum | null = null;

    public riders: Array<any> = [];
    public ridersForOverrideOrDownload: Array<any> = [];
    public cards: Array<InfoCardDto> = [];
    public lastActiveTypeList = LastActiveTypeModel.LastActiveTypeList;

    public arrayFilterStatuses: any = [
        { name: 'All', value: null },
        { name: DriverStatusEnum.TemporarySuspended, value: DriverStatusEnum.TemporarySuspended },
        { name: DriverStatusEnum.SuspendedFor7Days, value: DriverStatusEnum.SuspendedFor7Days },
        { name: DriverStatusEnum.SuspendedFor30Days, value: DriverStatusEnum.SuspendedFor30Days },
        { name: DriverStatusEnum.PendingReactivation, value: DriverStatusEnum.PendingReactivation },
        { name: DriverStatusEnum.Deactivated, value: DriverStatusEnum.Deactivated },
        { name: DriverStatusEnum.ExpiringDoc, value: DriverStatusEnum.ExpiringDoc },
        { name: DriverStatusEnum.Active, value: DriverStatusEnum.Active },
        { name: DriverStatusEnum.SignedUp, value: DriverStatusEnum.SignedUp },
        { name: DriverStatusEnum.Drafted, value: DriverStatusEnum.Drafted },
        { name: DriverStatusEnum.OnReview, value: DriverStatusEnum.OnReview },
        { name: DriverStatusEnum.Banned, value: DriverStatusEnum.Banned },
        { name: DriverStatusEnum.RegistrationApproved, value: DriverStatusEnum.RegistrationApproved },
        { name: DriverStatusEnum.RegistrationRejected, value: DriverStatusEnum.RegistrationRejected },
        { name: DriverStatusEnum.NoSchedule, value: DriverStatusEnum.NoSchedule },
        { name: DriverStatusEnum.AwaitingTraining, value: DriverStatusEnum.AwaitingTraining },
        { name: DriverStatusEnum.TrainingMissed, value: DriverStatusEnum.TrainingMissed },
        { name: DriverStatusEnum.TrainingPassed, value: DriverStatusEnum.TrainingPassed },
        { name: DriverStatusEnum.TrainingFailed, value: DriverStatusEnum.TrainingFailed },
        { name: DriverStatusEnum.AwaitingAssessment, value: DriverStatusEnum.AwaitingAssessment },
        { name: DriverStatusEnum.AssessmentMissed, value: DriverStatusEnum.AssessmentMissed },
        { name: DriverStatusEnum.AssessmentPassed, value: DriverStatusEnum.AssessmentPassed },
        { name: DriverStatusEnum.AssessmentFailed, value: DriverStatusEnum.AssessmentFailed },
        { name: DriverStatusEnum.PendingActivation, value: DriverStatusEnum.PendingActivation },
        { name: DriverStatusEnum.Activated, value: DriverStatusEnum.Activated },
        { name: DriverStatusEnum.Invited, value: DriverStatusEnum.Invited },
    ];

    public arrayFilterRatings: any = [
        { name: 'All', value: null },
        { name: '1 Star', value: 1 },
        { name: '2 Stars', value: 2 },
        { name: '3 Stars', value: 3 },
        { name: '4 Stars', value: 4 },
        { name: '5 Stars', value: 5 },
    ];

    public cols: any[] = [];

    private initializeCols() {
        if (this.isTaxiOrConnexDriversBackOffice()) {
            this.cols = [
                {
                    field: 'Id', fieldType: FieldTypeEnum.InputNumber, model: 'driverId',
                    placeholder: 'Type here', header: 'Driver ID', width: '20%', active: false
                },
                {
                    field: 'UserName', fieldType: FieldTypeEnum.Inputs, model: 'driverName',
                    placeholder: 'Type here', header: 'Name', width: '20%', active: false
                },
                {
                    field: 'Phone', fieldType: FieldTypeEnum.Inputs, model: 'phone',
                    placeholder: 'Type here', header: 'Phone No.', width: '20%', active: false
                },
                {
                    field: 'Vehicle', fieldType: FieldTypeEnum.Inputs, model: 'vehicle',
                    placeholder: 'Type here', header: 'Vehicle', width: '20%', active: false
                },
                {
                    field: 'PlateNumber', fieldType: FieldTypeEnum.Inputs, model: 'plateNumber',
                    placeholder: 'Type here', header: 'Plate Number', width: '20%', active: false
                },
                {
                    field: 'CountTrips', fieldType: FieldTypeEnum.InputNumber, model: 'countTrips',
                    placeholder: 'Type here', header: 'COMP', width: '20%', active: false
                },
                {
                    field: 'AcceptanceRate', fieldType: FieldTypeEnum.InputNumber, model: 'acceptanceRate',
                    placeholder: 'Type here', header: 'ACPT %', width: '20%', active: false
                },
                {
                    field: 'CompleteRate', fieldType: FieldTypeEnum.InputNumber, model: 'completeRate',
                    placeholder: 'Type here', header: 'COMP %', width: '20%', active: false
                },
                {
                    field: 'CancellationRate', fieldType: FieldTypeEnum.InputNumber, model: 'cancellationRate',
                    placeholder: 'Type here', header: 'CXL %', width: '20%', active: false
                },
                {
                    field: 'Rating', fieldType: FieldTypeEnum.Dropdown, options: this.arrayFilterRatings, model: 'rating',
                    placeholder: 'Please Select', header: 'Rating', width: '20%', active: false
                },
                {
                    field: 'LastLogin', fieldType: FieldTypeEnum.Dropdown, options: this.lastActiveTypeList, model: 'lastActiveTypeObj',
                    placeholder: 'Please Select', header: 'Last Online', width: '20%', take: 'obj', disableSort: true, active: false
                },
                {
                    field: 'Status', fieldType: FieldTypeEnum.Dropdown, options: this.arrayFilterStatuses, model: 'status',
                    placeholder: 'Please Select', header: 'Status', width: '20%', active: false
                }
            ];
        } else {
            this.cols = [
                {
                    field: 'Id', fieldType: FieldTypeEnum.InputNumber, model: 'driverId',
                    placeholder: 'Type here', header: 'Driver ID', width: '20%', active: false
                },
                {
                    field: 'UserName', fieldType: FieldTypeEnum.Inputs, model: 'driverName',
                    placeholder: 'Type here', header: 'Name', width: '20%', active: false
                },
                {
                    field: 'Phone', fieldType: FieldTypeEnum.Inputs, model: 'phone',
                    placeholder: 'Type here', header: 'Phone No.', width: '20%', active: false
                },
                {
                    field: 'Email', fieldType: FieldTypeEnum.Inputs, model: 'email',
                    placeholder: 'Type here', header: 'Email', width: '20%', active: false
                },
                {
                    field: 'CountTrips', fieldType: FieldTypeEnum.InputNumber, model: 'countTrips',
                    placeholder: 'Type here', header: 'COMP', width: '20%', active: false
                },
                {
                    field: 'AcceptanceRate', fieldType: FieldTypeEnum.InputNumber, model: 'acceptanceRate',
                    placeholder: 'Type here', header: 'ACPT %', width: '20%', active: false
                },
                {
                    field: 'CompleteRate', fieldType: FieldTypeEnum.InputNumber, model: 'completeRate',
                    placeholder: 'Type here', header: 'COMP %', width: '20%', active: false
                },
                {
                    field: 'CancellationRate', fieldType: FieldTypeEnum.InputNumber, model: 'cancellationRate',
                    placeholder: 'Type here', header: 'CXL %', width: '20%', active: false
                },
                {
                    field: 'Rating', fieldType: FieldTypeEnum.Dropdown, options: this.arrayFilterRatings, model: 'rating',
                    placeholder: 'Please Select', header: 'Rating', width: '20%', active: false
                },
                {
                    field: 'LastLogin', fieldType: FieldTypeEnum.Dropdown, options: this.lastActiveTypeList, model: 'lastActiveTypeObj',
                    placeholder: 'Please Select', header: 'Last Online', width: '20%', take: 'obj', disableSort: true, active: false
                },
                {
                    field: 'Status', fieldType: FieldTypeEnum.Dropdown, options: this.arrayFilterStatuses, model: 'status',
                    placeholder: 'Please Select', header: 'Status', width: '20%', active: false
                }
            ];
        }
        this.defaultCols = this.cols.map(x => x);
    }
    public defaultCols = this.cols.map(x => x);

    // Grid settings
    public rowsPerPage: number = Utils.getRowsPerPageCount();
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;
    public skip: number = 0;

    public filterObj: any = {
        serviceType: null,
        signupDate: null
    };

    public filter: {
        searchName: string;
        startDateJoin: Date | undefined;
        endDateJoin: Date | undefined;
    } = { searchName: '', startDateJoin: undefined, endDateJoin: undefined };

    public driverHeaderSearch: any = {
        driverId: null,
        driverName: null,
        countTrips: null,
        completeRate: null,
        acceptanceRate: null,
        cancellationRate: null,
        rating: null,
        lastActiveTypeObj: null,
        status: null,
        email: null,
        phone: null,
		vehicle: null,
		plateNumber: null,

        affiliation: null,
        signupDate: null,
        region: null,
        service: null,
        riderSourceType: null,
        address: null,
        driverCampaign: null,
        probationExpired: null,
        probationExpiring: null
    };

    public arrayPhonePrefixes: any = [
        { name: '+ 63', value: '+ 63' }
    ];

    inviteTypesList: Array<any> = [
        { name: 'Single Invite', value: InviteType.Single },
        { name: 'Bulk Invite', value: InviteType.Bulk },
    ];
    selectedInviteType!: InviteType;

    public selectedDriver: any;

    private refreshTimer: number = 0;
    public loading: boolean = false;
    public importedRowsAlreadyExist: boolean = false;

    public rowsDetected: number = 0;
    public rowsUploaded: number = 0;
    public rowsAlreadyExisting: number = 0;
    public rowsError: number = 0;

    private searchTimer: number = 0;

    public driverId!: number;
    public visibleFilter: boolean = false;
    public visibleDetail: boolean = false;
    public visibleProductTransactions: boolean = false;
    public visibleProductDetails: boolean = false;

    public showRemoveRiderPopup: boolean = false;
    public selectedRider: any;

    public showEditFields: boolean = false;

    public showDriverAddSideBar: boolean = false;

    public showDriversCompaignExportSidebar: boolean = false;

    public displayModalSuspend: boolean = false;
    public suspendUser: {
        userId: number | null;
        userName: string | null;
    } = { userId: null, userName: null };

    public riderSourceType = RiderSourceTypeEnum;
    public riderSourceTypeList = RiderSourceType.RiderSourceTypeList;
    public driverCampaignList: any[] = [];
    public selectedCampaign!: any;

    public visibleCampaignDialog: boolean = false;

    $drivers: Observable<any>;
    $driversSubject: Subscription | undefined;

    public xpress50IncentiveType = Xpress50IncentiveType; //Only for 4W
    public selectedXpress50IncentiveType: any; //Only for 4W
    public driverCampaignTypeEnum = DriverCampaignType;
    public productDetails!: ProductsAvailed;
    public riderId!: number;
    public commerceId!: number;
    public isCommerceTab: boolean = false;
    public isLGUAdmin: boolean = false;

    constructor(
        private messageService: MessageService,
        private riderService: RiderService,
        public configService: ConfigService,
        public app: AppComponent,
        private xpressUserService: XpressUserService,
        private signalRService: SignalrService,
        public appData: AppDataService,
        private operatorDriversService: OperatorDriversService,
        protected elRef: ElementRef,
        protected renderer: Renderer2,
        @Inject(TEST_ID_TOKEN) protected componentTestId: string) {
        this.renderer.setAttribute(this.elRef.nativeElement, 'data-testid', this.componentTestId);
        this.$drivers = this.signalRService.RidersObservable;
        this.isLGUAdmin = this.appData.hasPermission(MenuPermissionConfig.LGU_ADMIN, MenuPermissionActionEnum.Read);
    }

    private initDriverCampaignList() {
        if (this.appData.isBoracayLocation) {
            this.driverCampaignList.push({ id: DriverCampaignType.Boracay, name: 'Boracay Campaign' });
        }
        else if (this.backOfficeActive === BackOfficeEnum.Passenger2W) {
            this.driverCampaignList = [
                { id: DriverCampaignType.CampaignDriver, name: 'Campaign Driver' },
                { id: DriverCampaignType.Xpress50, name: 'Xpress 50' }
            ];
        }
        else if (this.backOfficeActive === BackOfficeEnum.Passenger4W) {
            this.driverCampaignList = [
                { id: DriverCampaignType.Xpress50Rider4W, name: 'Xpress 50 4W' },
                { id: DriverCampaignType.PriorityOrders, name: 'Priority Orders' }];
        }
        else {
            this.driverCampaignList = [
                { id: DriverCampaignType.CampaignDriver, name: 'Campaign Driver' },
                { id: DriverCampaignType.Xpress50, name: 'Xpress 50' }
            ];
        }
    }

    ngOnInit(): void {
        this.isCommerceTab = false;
        this.initializeCols();
        this.signalRService.startConnection().then(() => {
            console.log('signalR Service connected');
            this.signalRService.addUpdateRidersListener();
            this.$driversSubject = this.$drivers.subscribe((data: any) => {
                this.getRiders(this.skip);
                this.initialPermission = this.menuPermissionActive;
                console.log('signalR Service: updated riders');
            });
        });
    }

    loadColumnSelectorSettings() {
        if (this.columnSelector) {
            this.tableName = this.operatorDriversService.getTableContextName(
                this.menuPermissionActive,
                this.app.backOfficeRoot
            );
            this.columnSelector.loadTableSettings(this.tableName);
        }
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    ngAfterViewInit() {
        if (this.appData.xpressUserRoleId === XpressUserRoleEnum.Operator) {
            this.invitesDropdown.el.nativeElement.firstChild.style.backgroundColor = '#004060';
            this.invitesDropdown.el.nativeElement.firstChild.style.borderRadius = '28px';
            this.invitesDropdown.el.nativeElement.firstChild.children[2].style.color = '#FFF';
        }
    }

    isInviteBtnInactive(): boolean {
        if (this.selectedInviteType === InviteType.Single) {
            return !this.invitedDriverFilled() || this.loading || this.invitePhoneValidating;
        } else if (this.selectedInviteType === InviteType.Bulk) {
            return !this.csvFileUploaded || this.loading;
        }

        return false;
    }

    invitedDriverFilled(): boolean {
        if (!this.invitePhoneValidated
            || !this.invitePhoneValidationSuccess
            || Utils.isNullOrEmpty(this.singleInvitedDriver.Phone)
            || !this.isInviteEmailValid()) {
            return false;
        }

        if (this.inviteRequiresRegistration) {
            return this.isInviteEmailFormatValid(this.singleInvitedDriver.Email);
        }

        return !Utils.isNullOrEmpty(this.singleInvitedDriver.FirstName)
            && !Utils.isNullOrEmpty(this.singleInvitedDriver.LastName);
    }

    isInvitePhoneFormatValid(): boolean {
        return /^9\d{9}$/.test((this.invitePhoneLocal || '').trim());
    }

    isValidateInvitePhoneBtnInactive(): boolean {
        return !this.isInvitePhoneFormatValid() || this.invitePhoneValidating || this.loading;
    }

    onInvitePhoneInput(): void {
        this.invitePhoneLocal = (this.invitePhoneLocal || '').replace(/\D/g, '').slice(0, 10);
        this.singleInvitedDriver.Phone = this.invitePhoneLocal
            ? `${this.invitePhoneCountryCode}${this.invitePhoneLocal}`
            : '';
        this.clearInvitePhoneValidation();
    }

    isInviteEmailFormatValid(email: string | null | undefined): boolean {
        const value = (email ?? '').trim();
        return !!value && Utils.emailRegex.test(value);
    }

    isInviteEmailValid(): boolean {
        const email = (this.singleInvitedDriver.Email || '').trim();
        if (this.inviteRequiresRegistration) {
            return this.isInviteEmailFormatValid(email);
        }

        return !email || this.isInviteEmailFormatValid(email);
    }

    onInviteEmailInput(): void {
        const email = (this.singleInvitedDriver.Email || '').trim();
        if (!email) {
            this.inviteEmailError = '';
            this.inviteEmailAvailable = false;
            return;
        }

        const valid = this.isInviteEmailFormatValid(email);
        this.inviteEmailError = valid ? '' : 'Please enter a valid email address.';
        this.inviteEmailAvailable = valid && this.invitePhoneValidationSuccess && !this.inviteRequiresRegistration;
    }

    clearInvitePhoneValidation(): void {
        this.invitePhoneValidating = false;
        this.invitePhoneValidated = false;
        this.invitePhoneValidationSuccess = false;
        this.invitePhoneValidationSeverity = 'error';
        this.invitePhoneValidationMessage = '';
        this.inviteDetailsLocked = false;
        this.inviteRequiresRegistration = false;
        this.inviteEmailError = '';
        this.inviteEmailAvailable = false;
        this.singleInvitedDriver.FirstName = '';
        this.singleInvitedDriver.LastName = '';
        this.singleInvitedDriver.Email = '';
    }

    resetSingleInviteForm(): void {
        this.singleInvitedDriver = new InvitedDriver();
        this.invitePhoneLocal = '';
        this.clearInvitePhoneValidation();
    }

    validateInvitePhone(): void {
        if (this.isValidateInvitePhoneBtnInactive()) {
            return;
        }

        this.invitePhoneValidating = true;
        this.invitePhoneValidated = false;
        this.invitePhoneValidationSuccess = false;
        this.invitePhoneValidationMessage = '';
        this.inviteDetailsLocked = false;
        this.inviteRequiresRegistration = false;

        const phone = `${this.invitePhoneCountryCode}${this.invitePhoneLocal}`;
        this.singleInvitedDriver.Phone = phone;

        this.operatorDriversService.validateInvitePhone(phone, this.messageService)
            .then(data => {
                if (this.singleInvitedDriver.Phone !== phone) {
                    return;
                }

                this.invitePhoneValidating = false;
                this.invitePhoneValidated = true;

                if (!data?.Success) {
                    this.invitePhoneValidationSuccess = false;
                    this.invitePhoneValidationSeverity = 'error';
                    this.invitePhoneValidationMessage = data?.ErrorMessage
                        || 'Unable to validate mobile number.';
                    return;
                }

                this.invitePhoneValidationSuccess = !!data.IsEligible;
                this.inviteRequiresRegistration = !!data.RequiresRegistration;
                this.invitePhoneValidationSeverity = data.Severity === 'info'
                    || data.Severity === 'success'
                    || data.Severity === 'error'
                    || data.Severity === 'warning'
                    ? data.Severity
                    : (data.IsEligible ? 'success' : 'error');
                this.invitePhoneValidationMessage = data.Message
                    || (data.IsEligible
                        ? (data.RequiresRegistration
                            ? 'No Xpress account. Enter their phone number, a registration invite will be sent to onboard via driver Registration v2.'
                            : 'Active Xpress account found. This driver can be invited.')
                        : 'No active Xpress driver found for this mobile number.');

                this.singleInvitedDriver.FirstName = data.FirstName || '';
                this.singleInvitedDriver.LastName = data.LastName || '';
                this.singleInvitedDriver.Email = data.Email || '';
                this.inviteDetailsLocked = !this.inviteRequiresRegistration && !!(data.FirstName || data.LastName);
                this.onInviteEmailInput();
            })
            .catch(() => {
                if (this.singleInvitedDriver.Phone !== phone) {
                    return;
                }

                this.invitePhoneValidating = false;
                this.invitePhoneValidated = true;
                this.invitePhoneValidationSuccess = false;
                this.invitePhoneValidationSeverity = 'error';
                this.invitePhoneValidationMessage = 'Unable to validate mobile number.';
            });
    }

    ngOnDestroy(): void {
        this.signalRService?.disconnect();
        this.$driversSubject?.unsubscribe();
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        this.skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.tableName = this.operatorDriversService.getTableContextName(
            this.menuPermissionActive,
            this.app.backOfficeRoot
        );
        this.loadColumnSelectorSettings();
        this.visibleDetail = this.initialPermission === this.menuPermissionActive;
        this.getRiders(this.skip);
        this.lazyLoadHandled = false;
    }

    openInviteDialog() {
        this.showInviteDialog = true;
    }

    closeInviteDialog() {
        this.showInviteDialog = false;
        this.resetSingleInviteForm();
        this.importedRowsAlreadyExist = false;
    }

    singleInvite() {
        this.inviteDialogHeader = 'Single Invite';
        this.selectedInviteType = InviteType.Single;
        this.resetSingleInviteForm();
        this.openInviteDialog();
    }

    bulkInvite() {
        this.inviteDialogHeader = 'Bulk Invite';
        this.selectedInviteType = InviteType.Bulk;
        this.openInviteDialog();
    }

    sendInvite() {
        if (this.loading) {
            return;
        }
        if (this.selectedInviteType === InviteType.Single && !this.invitedDriverFilled()) {
            return;
        } else if (this.selectedInviteType === InviteType.Bulk && !this.csvFileUploaded) {
            return;
        }

        this.loading = true;

        if (this.selectedInviteType === InviteType.Single && this.invitedDriverFilled()) {
            this.sendInviteQuery(this.operatorDriversService.sendSingleInvite({
                firstName: this.singleInvitedDriver.FirstName,
                lastName: this.singleInvitedDriver.LastName,
                phone: this.singleInvitedDriver.Phone,
                email: this.singleInvitedDriver.Email,
                riderLocationType: this.appData.getClientLocationType()
            }, this.messageService));
        }
        else if (this.selectedInviteType === InviteType.Bulk && this.csvFileUploaded) {
            const dto = new FormData();
            dto.append('formFile', this.file);
            dto.append('locationType', this.appData.getClientLocationType().toString());
            this.sendInviteQuery(this.riderService.uploadInvitedRiders(dto, this.messageService));
        }
    }

    sendInviteQuery(query: Promise<any>) {
        query.then(data => {
            this.loading = false;

            if (!data.Success) {
                this.afterUploadError();
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }

            this.getRiders(0);
            this.ridersForOverrideOrDownload = data.Items;
            if (this.ridersForOverrideOrDownload && this.ridersForOverrideOrDownload.length > 0) {
                this.importedRowsAlreadyExist = true;
                this.inviteDialogHeader = 'Status';
                this.rowsDetected = data.RowsDetected;
                this.rowsUploaded = data.RowsUploaded;
                this.rowsAlreadyExisting = data.RowsAlreadyExisting;
                this.rowsError = data.RowsError;
            }

            if (!this.importedRowsAlreadyExist) {
                this.closeInviteDialog();
                this.deleteUpload();

                const invitedText = this.selectedInviteType === InviteType.Single
                    ? 'The invitee now appears in Invited Drivers as "Invited". It expires in 7 days.'
                    : 'Invitees now appear in Invited Drivers as "Invited". Invites expire in 7 days.';
                this.afterUploadSuccess(
                    this.selectedInviteType === InviteType.Single ? 'Fleet invite sent' : 'Fleet invites sent',
                    invitedText
                );
            }
        })
            .catch(err => {
                this.loading = false;
                this.afterUploadError();
                throw err;
            });
    }

    downloadError() {
        if (!this.ridersForOverrideOrDownload) {
            return;
        }
        this.loading = true;

        this.riderService.downloadExistingRiders(this.ridersForOverrideOrDownload, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data) {
                    return;
                }

                Utils.saveFileResponse(data, 'RidersRemarks_' + moment(new Date()).format('DD MMM YYYY hh:mm:ss A'), ExportFileTypeEnum.CSV);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    overrideInvitedRiders() {
        if (!this.ridersForOverrideOrDownload || this.loading) {
            return;
        }
        this.loading = true;
        this.riderService.overrideInvitedRiders(this.ridersForOverrideOrDownload, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.closeInviteDialog();
                this.deleteUpload();
                this.getRiders(0);
                this.importedRowsAlreadyExist = false;
                this.messageService.add({ severity: 'success', summary: 'Override success', detail: 'The changes have been applied.' });
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

	isActiveDrivers() {
        return this.operatorDriversService.isOperatorDriversMenu(this.menuPermissionActive);
    }

    onFileDropped(event: any) {
        this.prepareFiles(event);
    }

    fileBrowseHandler(files: any) {
        this.prepareFiles(files);
    }

    prepareFiles(files: any) {
        this.deleteUpload();
        let filesArr: any[];
        filesArr = files?.target?.files ? Array.from(files.target.files) : Array.from(files);
        filesArr = filesArr.filter((uploadedFile: File) => uploadedFile.type === 'text/csv');
        filesArr = filesArr.filter((uploadedFile: File) => uploadedFile.size <= DriversComponent.MAX_UPLOAD_FILE_SIZE);
        filesArr = filesArr.slice(0, 1);

        this.uploadDocuments(filesArr);
    }

    uploadDocuments(files: File[]) {
        if (!files || !files.length) {
            this.invitedDriversUploadError = true;
            return;
        }

        this.file = files[0];
        this.invitedDriversUploadError = false;
        this.invitedInterval = setInterval(() => {
            if (this.invitedDriversProgressBar === 100) {
                clearInterval(this.invitedInterval);
                this.csvFileUploaded = true;
            } else {
                this.invitedDriversProgressBar += 5;
            }
        }, 50);
    }

    afterUploadSuccess(invitedHeader: string, invitedText: string) {
        this.invitedDriversProgressBar = 100;
        this.messageService.add({ severity: 'success', summary: invitedHeader, detail: invitedText });
    }

    afterUploadError() {
        clearInterval(this.invitedInterval);
        this.invitedDriversProgressBar = 0;
        this.invitedDriversUploadError = true;
    }

    cancelUpload() {
        clearInterval(this.invitedInterval);
        this.invitedDriversProgressBar = 0;
        this.file = null;
    }

    deleteUpload() {
        this.file = null;
        this.csvFileUploaded = false;
        this.invitedDriversProgressBar = 0;
        this.invitedDriversUploadError = false;
    }

    getRiders(skip: number) {
        this.loading = true;
        this.initDriverCampaignList();
        const driverId = sessionStorage.getItem('driverId');

        this.operatorDriversService.fetchDrivers({
            operatorId: this.appData.authData.OperatorId,
            clientLocationType: this.appData.getClientLocationType(),
            skip,
            take: this.rowsPerPage,
            sortField: this.sortField,
            sortOrder: this.sortOrder,
            headerSearch: this.driverHeaderSearch,
            filter: {
                searchName: this.filter.searchName,
                startDateJoin: this.filter.startDateJoin,
                endDateJoin: this.filter.endDateJoin,
                serviceType: this.filterObj.serviceType ?? null,
                vehicleType: this.filterObj.vehicleType ?? null,
                signupDate: this.filterObj.signupDate ?? null
            },
            driverServiceTypes: this.driverServiceTypes,
            driverVehicleTypes: this.driverVehicleTypes,
            riderType: this.riderType,
            sessionDriverId: driverId,
            useActiveDriverStatuses: this.menuHomeEnumActive === MenuHomeEnum.ActiveDrivers,
            invitedDriversOnly: this.invitedDriversOnly
        }, this.messageService)
            .then(result => {
                this.loading = false;

                if (!result.success) {
                    sessionStorage.removeItem('driverId');
                    if (result.errorMessage) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: result.errorMessage });
                    }
                    return;
                }

                this.cards = result.cards;
                this.first = skip;
                this.totalRecords = result.totalRecords;
                this.riders = result.items as any[];
                sessionStorage.removeItem('driverId');
            })
            .catch(err => {
                sessionStorage.removeItem('driverId');
                this.loading = false;
                throw err;
            });
    }

    public getStatusStyles(status: any): StylesStatus {
        let backgroundColor: string;
        let textColor: string;
        switch (status) {
            case DriverStatusEnum.TemporarySuspended:
                backgroundColor = '#F77F00';
                textColor = '#311900';
                break;
            case DriverStatusEnum.SuspendedFor7Days:
                backgroundColor = '#FBD9D7';
                textColor = '#2F0D0B';
                break;
            case DriverStatusEnum.SuspendedFor30Days:
                backgroundColor = '#EB4236';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.Banned:
                backgroundColor = '#8D2820';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.PendingReactivation:
                backgroundColor = '#FFC043';
                textColor = '#664D1B';
                break;
            case DriverStatusEnum.Deactivated:
                backgroundColor = '#282E38';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.ExpiringDoc:
                backgroundColor = '#997328';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.Active:
                backgroundColor = '#1CBA70';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.SignedUp:
                backgroundColor = '#D2F1E2';
                textColor = '#0B4A2D';
                break;
            case DriverStatusEnum.Drafted:
                backgroundColor = '#354F61';
                textColor = '#FFFFFF';
                break;
            case DriverStatusEnum.OnReview:
                backgroundColor = '#9AA7B0';
                textColor = '#01070C';
                break;
            case DriverStatusEnum.RegistrationApproved:
                backgroundColor = '#1CBA70';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.RegistrationRejected:
                backgroundColor = '#EB4236';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.NoSchedule:
                backgroundColor = '#212121';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.AwaitingTraining:
                backgroundColor = '#99B3BF';
                textColor = '#000D13';
                break;
            case DriverStatusEnum.TrainingMissed:
                backgroundColor = '#F85C3A';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.TrainingPassed:
                backgroundColor = '#49C88D';
                textColor = '#0B4A2D';
                break;
            case DriverStatusEnum.TrainingFailed:
                backgroundColor = '#EF685E';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.AwaitingAssessment:
                backgroundColor = '#004060';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.AssessmentMissed:
                backgroundColor = '#FEDED8';
                textColor = '#76211B';
                break;
            case DriverStatusEnum.AssessmentPassed:
                backgroundColor = '#117043';
                textColor = '#D2F1E2';
                break;
            case DriverStatusEnum.AssessmentFailed:
                backgroundColor = '#8D2820';
                textColor = '#FBD9D7';
                break;
            case DriverStatusEnum.PendingActivation:
                backgroundColor = '#CEE6FF';
                textColor = '#043566';
                break;
            case DriverStatusEnum.Activated:
                backgroundColor = '#0A84FF';
                textColor = '#CEE6FF';
                break;
            case DriverStatusEnum.Invited:
                backgroundColor = '#7356BF';
                textColor = '#FFF';
                break;
            case DriverStatusEnum.InviteExpired:
                backgroundColor = '#E5E7EB';
                textColor = '#374151';
                break;
            case DriverStatusEnum.Declined:
                backgroundColor = '#FBD9D7';
                textColor = '#8D2820';
                break;
            case DriverStatusEnum.PendingVerification:
                backgroundColor = '#CEE6FF';
                textColor = '#043566';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    public onSelectInviteType(inviteType: InviteType) {
        if (inviteType === InviteType.Single) {
            this.singleInvite();
        } else if (inviteType === InviteType.Bulk) {
            this.bulkInvite();
        }
    }

    public onChangeDateAndDropDown(event: any) {
        this.getRiders(0);
    }

    public dateFilterChange(datesFilter: any) {
        this.filter.startDateJoin = datesFilter.startDate;
        this.filter.endDateJoin = datesFilter.endDate;
        if (!this.firstLoad) {
            this.getRiders(0);
        }
        this.firstLoad = false;
    }

    public handleHeaderFilterChange(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        if (model === 'Phone') {
            this.driverHeaderSearch.phone = event.target.value;
        }

        this.searchTimer = window.setTimeout(() => {
            this.getRiders(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getRiders(0);
            this.searchTimer = 0;
        }, 1500);
    }

    changedVisibleDetailEmit(value: any) {
        this.visibleDetail = value;
        this.isCommerceTab = false;
    }

    changedDisplayFilterEmit(value: any) {
        this.visibleFilter = value;
    }

    public removeRider() {
        const dto = {
            XpressUserId: this.selectedRider.XpressUserId
        };
        this.loading = true;
        this.xpressUserService.removeUser(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rider has been deleted' });
                this.showRemoveRiderPopup = false;
                this.getRiders(0);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public addToCampaign() {
        if (!this.selectedCampaign) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select a campaign' });
            return;
        }

        if (this.selectedCampaign === DriverCampaignType.Xpress50Rider4W && !this.selectedXpress50IncentiveType) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select an incentive type' });
            return;
        }

        const dto = {
            RiderId: this.driverId,
            IsBelongCompany: (this.selectedCampaign === DriverCampaignType.CampaignDriver) ? true : null,
            IsBelongXpress50: (this.selectedCampaign === DriverCampaignType.Xpress50) ? true : null,
            AssignedToBoracayCampaign: (this.selectedCampaign === DriverCampaignType.Boracay) ? true : null,
            IsXpress50Rider4W: (this.selectedCampaign === DriverCampaignType.Xpress50Rider4W) ? true : null,
            PriorityOrders: (this.selectedCampaign === DriverCampaignType.PriorityOrders) ? true : null,
            Xpress50IncentiveType: this.selectedXpress50IncentiveType // Only for 4W am/pm
        };
        this.addOrRemoveRiderCampaign(dto, 'Rider added in to campaign');
    }

    public removeFromCampaign() {
        if (!this.selectedCampaign) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select a campaign' });
            return;
        }

        const dto = {
            RiderId: this.driverId,
            IsBelongCompany: (this.selectedCampaign === DriverCampaignType.CampaignDriver) ? false : null,
            IsBelongXpress50: (this.selectedCampaign === DriverCampaignType.Xpress50) ? false : null,
            AssignedToBoracayCampaign: (this.selectedCampaign === DriverCampaignType.Boracay) ? false : null,
            IsXpress50Rider4W: (this.selectedCampaign === DriverCampaignType.Xpress50Rider4W) ? false : null,
            PriorityOrders: (this.selectedCampaign === DriverCampaignType.PriorityOrders) ? false : null
        };
        this.addOrRemoveRiderCampaign(dto, 'Rider removed from campaign');
    }

    public addOrRemoveRiderCampaign(dto: any, successMessage: string) {
        this.loading = true;
        this.riderService.addOrRemoveRiderCampaign(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: successMessage });
                this.visibleCampaignDialog = false;
                this.selectedCampaign = null;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public showModalSuspend(user: any) {
        this.suspendUser = {
            userId: user.XpressUserId,
            userName: user.UserName
        };

        this.displayModalSuspend = !this.displayModalSuspend;
    }

    changedDisplayModalSuspendEmit(value: any) {
        this.displayModalSuspend = value;
    }

    public handleShowDriverInfo(driver: any) {
        if (driver.Status === DriverStatusEnum.Invited) {
            return;
        }

        if (this.isLGUAdmin) {
            return;
        }

        this.selectedDriver = driver;
        this.visibleDetail = true;
    }

    openDriverAddSideBar() {
        this.showDriverAddSideBar = true;
    }
    changedShowDriverAddSideBarEmit(value: any) {
        this.showDriverAddSideBar = value;
    }

    public handleShowDriversCompaignExportSidebar() {
        this.showDriversCompaignExportSidebar = true;
    }
    changedShowDriversCompaignExportSidebarEmit(value: any) {
        this.showDriversCompaignExportSidebar = value;
    }

    showCampaignDialog(riderObj: any) {
        this.driverId = riderObj.Id;
        this.visibleCampaignDialog = true;
    }

    callBackOfficeForFilter(backOffice: BackOfficeEnum) {
        switch (backOffice) {
            case BackOfficeEnum.Passenger2W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.Moto];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Ride,
                    ServiceTypeEnum.Hire,
                    ServiceTypeEnum.Transfer,
                    ServiceTypeEnum.ScanAndRide,
                    ServiceTypeEnum.Single,
					ServiceTypeEnum.Charter];
				this.riderType = DriverTypeEnum.Regular;
                break;
            case BackOfficeEnum.Passenger3W:
				if (this.appData.isDumagueteLocation) {
					this.driverVehicleTypes = [
						RiderVehicleTypeEnum.TrikeSixPax,
						RiderVehicleTypeEnum.TrikeFivePax];
					this.driverServiceTypes = [ServiceTypeEnum.Charter];
				} else {
					this.driverVehicleTypes = [RiderVehicleTypeEnum.ETrike, RiderVehicleTypeEnum.Multicab];
					this.driverServiceTypes = [
						ServiceTypeEnum.Ride,
						ServiceTypeEnum.Hire,
						ServiceTypeEnum.Transfer,
						ServiceTypeEnum.ScanAndRide,
						ServiceTypeEnum.Single,
						ServiceTypeEnum.Charter];
				}
				this.riderType = DriverTypeEnum.Regular;
                break;
            case BackOfficeEnum.Passenger4W:
                this.driverVehicleTypes = [
                    RiderVehicleTypeEnum.Sedan,
                    RiderVehicleTypeEnum.SUV,
                    RiderVehicleTypeEnum.Fastest,
                    RiderVehicleTypeEnum.PetTaxi,
                    RiderVehicleTypeEnum.Courier,
                    RiderVehicleTypeEnum.Cargo,
                    RiderVehicleTypeEnum.Van,
                    RiderVehicleTypeEnum.Minibus,
                    RiderVehicleTypeEnum.Multicab,
					RiderVehicleTypeEnum.EVCar,
					RiderVehicleTypeEnum.Comfort,
					RiderVehicleTypeEnum.Premium
                ];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Ride,
                    ServiceTypeEnum.Hire,
                    ServiceTypeEnum.Transfer,
                    ServiceTypeEnum.ScanAndRide,
                    ServiceTypeEnum.Single,
					ServiceTypeEnum.Charter];
				this.riderType = DriverTypeEnum.Regular;
                break;
            case BackOfficeEnum.Delivery2W:
                this.driverVehicleTypes = this.appData.isBoracayLocation
                    ? [RiderVehicleTypeEnum.Food, RiderVehicleTypeEnum.Grocery]
                    : [RiderVehicleTypeEnum.Moto];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Delivery,
                    ServiceTypeEnum.Food,
					ServiceTypeEnum.Grocery];
				this.riderType = DriverTypeEnum.Regular;
                break;
            case BackOfficeEnum.Delivery4W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.Sedan,
                RiderVehicleTypeEnum.SUV,
                RiderVehicleTypeEnum.Fastest,
                RiderVehicleTypeEnum.PetTaxi,
                RiderVehicleTypeEnum.Courier,
                RiderVehicleTypeEnum.Cargo,
                RiderVehicleTypeEnum.Van,
                RiderVehicleTypeEnum.Minibus,
                RiderVehicleTypeEnum.Multicab,
                RiderVehicleTypeEnum.EVCar];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Delivery,
                    ServiceTypeEnum.Food,
					ServiceTypeEnum.Grocery];
				this.riderType = DriverTypeEnum.Regular;
				break;
			case BackOfficeEnum.Taxi:
				this.driverVehicleTypes = [];
				this.driverServiceTypes = [];
				this.riderType = DriverTypeEnum.Taxi;
				break;
			case BackOfficeEnum.ConneX:
				this.driverVehicleTypes = [];
				this.driverServiceTypes = [];
				this.riderType = DriverTypeEnum.Connex;
				break;

            default:
                this.driverVehicleTypes = [];
				this.driverServiceTypes = [];
				this.riderType = null;
                break;
        }
    }

    showTransactions(event: any) {
        if (!event) {
            this.visibleProductTransactions = false;
            this.isCommerceTab = true;
        } else {
            this.visibleProductTransactions = true;
            this.riderId = event;
        }
    }

    showProductDetails(event: any) {
        this.visibleProductDetails = event;
        this.isCommerceTab = true;
    }

    showDetails(event: number) {
        if (event) {
            this.visibleProductTransactions = false;
            this.visibleProductDetails = true;
            this.commerceId = event;
        } else {
            this.visibleProductDetails = false;
        }
    }

    protected readonly InviteType = InviteType;
    protected readonly BusinessDocumentsEnum = BusinessDocumentsEnum;
    protected readonly Utils = Utils;
    protected readonly XpressCalendarEnum = XpressCalendarEnum;
    protected readonly XpressUserRoleEnum = XpressUserRoleEnum;

	isTaxiOrConnexDriversBackOffice(): boolean {
		return this.backOfficeActive === BackOfficeEnum.Taxi || this.backOfficeActive === BackOfficeEnum.ConneX;
	}

	/** RiderType для API при создании водителя из боковой формы (Taxi / ConneX). */
	getDriverCreationRiderType(): DriverTypeEnum {
		return this.backOfficeActive === BackOfficeEnum.ConneX ? DriverTypeEnum.Connex : DriverTypeEnum.Taxi;
	}
}

export class InfoCardDto {
    public Header: string = '';
    public Amount: string = '';
    public SubAmount: string = '';
    public LastUpdate: string = '';
    public VehicleBrandId: number = 0;
    public VehicleModelId: number = 0;
}

export class InvitedDriver {
    public FirstName: string = '';
    public LastName: string = '';
    public Phone: string = '';
    public Email: string = '';
}

export enum InviteType {
    Single = 1,
    Bulk = 2
}

export enum DriverStatusEnum {
    TemporarySuspended = 'Temporary Suspended',
    SuspendedFor7Days = 'Suspended for 7 days',
    SuspendedFor30Days = 'Suspended for 30 days',
    SignedUp = 'Signed Up',
    Drafted = 'Drafted',
    OnReview = 'On Review',
    Banned = 'Banned',
    PendingReactivation = 'Pending Reactivation',
    Deactivated = 'Deactivated',
    ExpiringDoc = 'Expiring Doc',
    Active = 'Active',
    RegistrationApproved = 'Registration - Approved',
    RegistrationRejected = 'Registration - Rejected',
    NoSchedule = 'No Schedule Selected',
    AwaitingTraining = 'Awaiting Classroom Training',
    TrainingMissed = 'Classroom Training Missed',
    TrainingPassed = 'Classroom Training Passed',
    TrainingFailed = 'Classroom Training Failed',
    AwaitingAssessment = 'Awaiting Skills Assessment',
    AssessmentMissed = 'Skills Assessment Missed',
    AssessmentPassed = 'Skills Assessment - Passed',
    AssessmentFailed = 'Skills Assessment - Failed',
    PendingActivation = 'Pending Activation',
    Activated = 'Activated',
    Invited = 'Invited',
    InviteExpired = 'Invite Expired',
    Declined = 'Declined',
    PendingVerification = 'Pending Verification'
}
